import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "common";
export const initialState = {
    location: undefined,
    isLogOut: false,
    isLeaveFormFilled: null,
    modal: false,
};

const commonReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setLocation: (state, action) => ({
            ...state,
            location: action.payload
        }),
        setIsLogOut: (state, action) => ({
            ...state,
            isLogOut: action.payload
        }),
        setUserInfo: (state, action) => ({
            ...state,
            isLeaveFormFilled: action.payload
        }),
        setModal: (state, action) => ({
            ...state,
            modal: action.payload
        }),
    }
});

export default commonReducer.reducer;
export const {
    setLocation,
    setIsLogOut, setUserInfo,
    setModal,
} = commonReducer.actions;

